import { getRailsEnv } from './rails_helper'

// helpers for interaction with live regions inserted into layout
// ensure that LiveRegionComponent.rb is rendered in your application layout

const getLiveRegion = value => {
  const region = document.getElementById(`live-region-${value}`)
  if (region) return region
  console.error(`Missing live region with value ${value}; ensure it is rendered in your application layout`)
}

const setLiveRegionContent = value => content => {
  const region = getLiveRegion(value)
  if (getRailsEnv() === 'development') {
    console.info(`Setting content for ${value} live region: '${content}'`)
  }
  // This is kind of hacky, but AFAICT it's the only way to get the live region to re-announce
  // identical content, e.g. in the case of the same toast read out twice in a row. In order for
  // the live region to pick this up as a new message, we add a period to differentiate it.
  if (region != null) {
    if (content === region.innerHTML) {
      region.innerHTML = content + '.'
    } else {
      region.innerHTML = content
    }
  }
}

const clearLiveRegionContent = value => () => {
  const region = getLiveRegion(value)
  region.innerHTML = ''
}

export const polite = {
  setContent(content) {
    setLiveRegionContent('polite')(content)
  },

  clearContent() {
    clearLiveRegionContent('polite')()
  }
}

export const assertive = {
  setContent(content) {
    setLiveRegionContent('assertive')(content)
  },

  clearContent() {
    clearLiveRegionContent('assertive')()
  }
}
